import { render } from "./MailchimpLogoIcon.vue?vue&type=template&id=1aca6146"
import script from "./MailchimpLogoIcon.vue?vue&type=script&lang=js"
export * from "./MailchimpLogoIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__